import React, { useEffect, useState } from "react";
import Deactivate from "../../confirmation_Screen/Deactivate";
import "./publishedQList.css";
import PublishedMcqType from "../PublishQuestionType/PublishedMcqType";
import PublishedImgType from "../PublishQuestionType/PublishedImgType";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "../../../../../axios";
import moment from "moment";
import {
  calculateDeadlineTime,
  dateHelperSchedulePlusDuration,
} from "../../../../../Utils/assessment";
import { timeHelper, dateHelper } from "../../../../../Utils/datetime_helper";
import {
  Box,
  Paper,
  Typography,
  Chip,
  Stack,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";

const PublishedQList = () => {
  const [click, setClick] = useState(false);
  const { state } = useLocation();
  const [assessment, setAssessment] = useState();
  const [isGettingData, setIsGettingData] = useState(true);

  let isFromDcm = localStorage.getItem("from");
  let supplement_id = JSON.parse(localStorage.getItem("supplementId"));

  useEffect(() => {
    const getAssessment = async () => {
      try {
        let res = await axios.get(
          `/api/v1/assessment/get/${state.assessmentId}`,
        );
        res && setAssessment(res.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    getAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const backTo =
    localStorage.getItem("Header") === "Content Management"
      ? "/contentMangment"
      : isFromDcm === "DCM"
        ? "/DcmTimeTable"
        : isFromDcm === "Summary"
          ? `/ViewSummary`
          : "/publishedAssessment";

  return (
    <Box
      className="container-fluid px-4 py-3"
      sx={{
        bgcolor: "#f7f8fa",
        height: "calc(100vh - 100px)",
        overflowY: "auto",
      }}
    >
      {!isGettingData ? (
        <>
          {/* ───────── Compact top bar ───────── */}
          <Paper
            elevation={0}
            sx={{
              px: 2.5,
              py: 1.5,
              mb: 2,
              borderRadius: 2.5,
              border: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            {/* Left — back + title + meta */}
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{ minWidth: 0 }}
            >
              {/* Back button */}
              <NavLink
                to={backTo}
                state={{ supplement_id: supplement_id }}
                style={{ textDecoration: "none" }}
              >
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#f3f4f6",
                    cursor: "pointer",
                    flexShrink: 0,
                    transition: "all .15s",
                    "&:hover": { bgcolor: "#e5e7eb" },
                  }}
                >
                  <ArrowBackIosNewRoundedIcon
                    sx={{ fontSize: 15, color: "#374151" }}
                  />
                </Box>
              </NavLink>

              <Box sx={{ minWidth: 0 }}>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  flexWrap="wrap"
                  useFlexGap
                >
                  <Typography
                    fontWeight={700}
                    fontSize={15}
                    color="#111827"
                    noWrap
                  >
                    {assessment?.name || "Loading…"}
                  </Typography>

                  <Chip
                    icon={
                      <CheckCircleRoundedIcon
                        sx={{ fontSize: "14px !important" }}
                      />
                    }
                    label="PUBLISHED"
                    size="small"
                    sx={{
                      height: 20,
                      bgcolor: "#dcfce7",
                      color: "#15803d",
                      fontWeight: 700,
                      fontSize: 10,
                      letterSpacing: 0.5,
                      "& .MuiChip-icon": { color: "#15803d" },
                    }}
                  />
                </Stack>

                {/* Meta line: subject · scheduled */}
                <Stack
                  direction="row"
                  spacing={1.25}
                  alignItems="center"
                  flexWrap="wrap"
                  useFlexGap
                  sx={{ mt: 0.3 }}
                >
                  {assessment?.subject_id?.name && (
                    <Typography fontSize={11} color="#4b5563" fontWeight={500}>
                      {assessment.subject_id.name}
                    </Typography>
                  )}

                  {assessment?.schedule_date && (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <CalendarMonthRoundedIcon
                        sx={{ fontSize: 12, color: "#9ca3af" }}
                      />
                      <Typography fontSize={11} color="#6b7280">
                        Scheduled{" "}
                        <span style={{ color: "#374151", fontWeight: 600 }}>
                          {dateHelper(assessment.schedule_date)} ·{" "}
                          {timeHelper(assessment.schedule_time || "")}
                        </span>
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              </Box>
            </Stack>

            {/* Right — stat chips */}
            <Stack direction="row" spacing={1.25} alignItems="center">
              <StatChip
                icon={
                  <HelpOutlineRoundedIcon
                    sx={{ fontSize: "16px !important" }}
                  />
                }
                label="Questions"
                value={assessment?.total_questions ?? 0}
                bg="#eef2ff"
                color="#3730a3"
              />

              <StatChip
                icon={
                  <EmojiEventsRoundedIcon
                    sx={{ fontSize: "16px !important" }}
                  />
                }
                label="Marks"
                value={assessment?.total_marks ?? 0}
                bg="#fef3c7"
                color="#b45309"
              />
            </Stack>
          </Paper>

          {/* ───────── Breadcrumb (optional, hidden on mobile) ───────── */}
          <Typography fontSize={11} color="#9ca3af" sx={{ mb: 2, px: 0.5 }}>
            {isFromDcm && (
              <>
                <Link
                  className="link"
                  to={isFromDcm === "DCM" ? "/DcmTimeTable" : `/ViewSummary`}
                  state={{ supplement_id: supplement_id }}
                  style={{ color: "#9ca3af", textDecoration: "none" }}
                >
                  {isFromDcm}
                </Link>
                {" / "}
              </>
            )}
            <Link
              to={
                localStorage.getItem("Header") === "Content Management"
                  ? "/contentMangment"
                  : "/publishedAssessment"
              }
              style={{ color: "#9ca3af", textDecoration: "none" }}
            >
              Assessment
            </Link>
            {" / "}
            <span style={{ color: "#4b5563" }}>{assessment?.name}</span>
          </Typography>

          {/* ───────── Questions list ───────── */}
          {assessment?.questions?.length >= 0 &&
            assessment?.questions?.map((question, index) => {
              if (
                question.type.name === "MCQ Type" ||
                !question.type.is_manually_graded
              ) {
                return (
                  <PublishedMcqType
                    key={index}
                    questionNumber={index + 1}
                    question={question}
                  />
                );
              } else {
                return (
                  <PublishedImgType
                    key={index}
                    questionNumber={index + 1}
                    question={question}
                  />
                );
              }
            })}

          {click && (
            <Deactivate assessmentId={state.assessmentId} onChange={setClick} />
          )}
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
          }}
        >
          <Stack alignItems="center" spacing={1.5}>
            <CircularProgress size={28} sx={{ color: "#2563eb" }} />
            <Typography fontSize={13} color="text.secondary">
              Loading…
            </Typography>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

/* ───────── Small reusable stat chip ───────── */
const StatChip = ({ icon, label, value, bg, color }) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={1}
    sx={{
      px: 1.5,
      py: 0.75,
      borderRadius: 2,
      bgcolor: bg,
      color: color,
      minWidth: 110,
    }}
  >
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        bgcolor: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: color,
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography
        fontSize={10}
        fontWeight={600}
        sx={{ textTransform: "uppercase", letterSpacing: 0.4, lineHeight: 1 }}
      >
        {label}
      </Typography>
      <Typography fontSize={15} fontWeight={700} sx={{ lineHeight: 1.2 }}>
        {value}
      </Typography>
    </Box>
  </Stack>
);

export default PublishedQList;
